"use client";

import clsx from 'clsx';
import * as React from 'react';
import FormGroup from './FormGroup.js';
import { useBootstrapPrefix } from './ThemeProvider.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FloatingLabel = /*#__PURE__*/React.forwardRef(({
  bsPrefix,
  className,
  children,
  controlId,
  label,
  ...props
}, ref) => {
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-floating');
  return /*#__PURE__*/_jsxs(FormGroup, {
    ref: ref,
    className: clsx(className, bsPrefix),
    controlId: controlId,
    ...props,
    children: [children, /*#__PURE__*/_jsx("label", {
      htmlFor: controlId,
      children: label
    })]
  });
});
FloatingLabel.displayName = 'FloatingLabel';
export default FloatingLabel;